import i18n from '@/i18n'
import { formatMoney } from '@/utils/NumericMutations'

export default {
  tractBidHeaders () {
    return [
      {
        sortable: true,
        text: i18n.t('name'),
        value: 'name'
      },
      {
        sortable: true,
        text: i18n.t('supplier'),
        value: 'supplierAccountName'
      },
      {
        sortable: true,
        text: i18n.t('destination'),
        value: 'destinationAccountName'
      },
      {
        sortable: true,
        text: i18n.t('bidDate'),
        value: 'bidDate'
      },
      {
        sortable: true,
        text: i18n.t('bidExpiration'),
        value: 'bidExpiration'
      },
      {
        sortable: true,
        text: i18n.t('rfbStatus'),
        value: 'rfbStatus'
      },
      {
        sortable: true,
        text: i18n.t('outcome'),
        value: 'outcome'
      },
      {
        sortable: false,
        text: i18n.t('actions'),
        value: 'actions',
        align: 'center'
      }
    ]
  },

  bidManagerHeaders (includeStatus = false) {
    return [
      ...(includeStatus
        ? [{
          sortable: false,
          text: i18n.t('status'),
          value: 'status',
          align: 'center'
        }]
        : []),
      {
        sortable: true,
        text: i18n.t('name'),
        value: 'name'
      },
      {
        sortable: true,
        text: i18n.t('tract'),
        value: 'tractName'
      },
      {
        sortable: true,
        text: i18n.t('supplier'),
        value: 'supplierAccountName'
      },
      {
        sortable: true,
        text: i18n.t('destination'),
        value: 'destinationAccountName'
      },
      {
        sortable: true,
        text: i18n.t('bidDate'),
        value: 'bidDate'
      },
      {
        sortable: true,
        text: i18n.t('bidExpiration'),
        value: 'bidExpiration'
      },
      {
        sortable: false,
        text: i18n.t('actions'),
        value: 'actions',
        align: 'center'
      }
    ]
  },

  bidProductHeaders (includeActions = true) {
    return [
      {
        sortable: true,
        text: i18n.t('product'),
        value: 'productName'
      },
      {
        sortable: true,
        text: i18n.t('volume'),
        value: 'harvestVolume',
        align: 'end'
      },
      {
        sortable: true,
        text: i18n.t('deliveredRate'),
        value: 'deliveredRate',
        align: 'end'
      },
      ...(includeActions
        ? [{
          sortable: false,
          text: i18n.t('actions'),
          value: 'actions',
          align: 'center'
        }]
        : [])
    ]
  },

  bidCostComponentHeaders () {
    return [
      {
        sortable: true,
        text: i18n.t('bidCostType'),
        value: 'bidCostTypeName',
        total: () => i18n.t('total')
      },
      {
        sortable: true,
        text: i18n.t('rate'),
        value: 'rate',
        align: 'end',
        format: formatMoney,
        total: ({ total }) => total
      }
    ]
  },

  bidTractStatHeaders () {
    return [
      {
        sortable: true,
        text: i18n.t('tractName'),
        value: 'tractName'
      },
      {
        sortable: true,
        text: i18n.t('state'),
        value: 'state'
      },
      {
        sortable: true,
        text: i18n.t('supplier'),
        value: 'supplierName'
      },
      {
        sortable: true,
        text: i18n.t('decidedDate'),
        value: 'decidedDate'
      },
      {
        sortable: true,
        text: i18n.t('bids'),
        value: 'bidCount',
        align: 'end'
      }
    ]
  },

  bidSupplierStatHeaders () {
    return [
      {
        sortable: true,
        text: i18n.t('supplier'),
        value: 'supplierName'
      },
      {
        sortable: true,
        text: i18n.t('won'),
        value: 'won',
        align: 'end'
      },
      {
        sortable: true,
        text: i18n.t('lost'),
        value: 'lost',
        align: 'end'
      },
      {
        sortable: true,
        text: i18n.t('open'),
        value: 'open',
        align: 'end'
      },
      {
        sortable: true,
        text: i18n.t('winRate'),
        value: 'winRate',
        align: 'end'
      }
    ]
  }
}
